import { Page, PageHeader } from "@dash/page";
import { QuerySkeleton } from "@dash/skeleton";
import { useContext } from "react";

import { IamAuthContext } from "@megaron/auth-react";
import { useClientManager } from "@megaron/react-clients";

import { DocExchangeStatusTable } from "./DocExchangeStatusTable";

export const DocsPage = () => {
  const auth = useContext(IamAuthContext);

  const docExchangeStatusQuery = useClientManager("docs")
    .docExchangeStatusQuery()
    .useQuery({}, { enabled: !!auth.iamUser });

  return (
    <Page css={{ maxWidth: "100%", marginTop: "2rem" }}>
      <PageHeader>Document exchanges</PageHeader>
      <QuerySkeleton query={docExchangeStatusQuery}>
        {(statuses) => <DocExchangeStatusTable statuses={statuses} isLoading={docExchangeStatusQuery.isFetching} />}
      </QuerySkeleton>
    </Page>
  );
};
